import React, { Fragment, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoFilter } from "react-icons/io5";
import { PuffLoader } from "react-spinners";
import { useSelector } from "react-redux";
import api from "../../../services/axiosConfig";
import { OPERDON_PAGING, OPERKIND_CAR } from "../../../constant-value";
import { selectCars } from "../../../redux/car/car-slice";
import CardOperdonView from "./card-operdon-vw";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import Filter from "../../operate/filter/filter";
import SpinnerWrapper from "../../pages/spinnerWrapper";
import ErrorBox from "../../pages/errorBox";

const OperdonInfinitPaging = () => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [index, setIndex] = useState(1);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openFilterPage, setOpenFilterPage] = useState(false);
  const [okItems, setOkItems] = useState([]);
  const ITEM_COUNT = 4;

  const cars = useSelector(selectCars);
  const [params, setParams] = useState(new URLSearchParams());

  // دریافت داده‌های نوع سرویس‌ها برای فیلتر
  useEffect(() => {
    api
      .get(`/${OPERKIND_CAR}`)
      .then((res) => setOkItems(res.data))
      .catch((err) => console.error("خطا در دریافت نوع سرویس:", err));
  }, []);

  // تابع دریافت داده‌ها (با در نظر گرفتن params و index)
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(false);

        const res = await api.get(
          `/${OPERDON_PAGING}?page=${index}&itemCount=${ITEM_COUNT}&${params.toString()}`
        );

        const newItems = res.data.operdones || [];

        if (index === 1) {
          setItems(newItems);
        } else {
          setItems((prev) => [...prev, ...newItems]);
        }

        // اگر تعداد آیتم‌ها کمتر از ITEM_COUNT بود یعنی آخر لیست رسیده‌ایم
        setHasMore(newItems.length === ITEM_COUNT);
      } catch (err) {
        console.error("خطا در واکشی داده‌ها:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    // ✅ فراخوانی تابع
    fetchData();
  }, [index, params]);

  // تابع بارگذاری صفحه بعد
  const fetchMoreData = () => {
    if (hasMore && !isLoading) {
      setIndex((prev) => prev + 1);
    }
  };

  // تابعی که از کامپوننت فیلتر داده می‌گیرد
  const handleDataFromChild = (getData) => {
    setIsLoading(true);
    setError(false);

    let newParams = new URLSearchParams();

    if (getData.carId && getData.carId.length > 0)
      getData.carId.forEach((value) => newParams.append("carId", value));

    if (getData.serviceType && getData.serviceType.length > 0)
      getData.serviceType.forEach((value) =>
        newParams.append("serviceType", value)
      );

    if (getData.ok_Id && getData.ok_Id !== "0")
      newParams.append("ok_Id", getData.ok_Id);

    if (getData.desc && getData.desc.trim() !== "")
      newParams.append("desc", getData.desc.trim());

    // تنظیم پارامترهای جدید و ریست صفحه به ۱
    setHasMore(true); // خیلی مهم: اجازه بده infinite scroll دوباره فعال بشه
    setItems([]);
    setIndex(1);

    // setParams(newParams);
      // این خط خیلی مهم است 👇👇
  setParams(new URLSearchParams(newParams.toString()));

    setOpenFilterPage(false);
  };

  return (
    <Fragment>
      {isLoading && index === 1 ? (
        <SpinnerWrapper>
          <PuffLoader color="green" loading={isLoading} size={60} />
        </SpinnerWrapper>
      ) : error ? (
        <ErrorBox />
      ) : (
        <>
          {/* دکمه باز شدن فیلتر */}
          <div className="d-flex justify-content-end mb-3">
            <button
              onClick={() => setOpenFilterPage(true)}
              type="button"
              className="btn btn-outline-info rounded-circle"
              style={{ width: "40px", height: "40px" }}
            >
              <IoFilter className="fs-5" />
            </button>
          </div>

          {/* فیلتر پایین صفحه */}
          <BottomSheet
            isOpen={openFilterPage}
            children={
              <Filter
                cars={cars}
                operKind={okItems}
                sendDataToParent={handleDataFromChild}
              />
            }
            onClose={() => {
              setOpenFilterPage(false);
            }}
          />

          <hr className="my-4" />

          {/* Infinite Scroll */}
          <InfiniteScroll
            key={params.toString()}  // 👈 این خط باعث می‌شود بعد از فیلتر کاملاً ریست شود
            dataLength={items.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="d-flex justify-content-center my-3">
                <div className="spinner-border text-info" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            }
            endMessage={
              <p className="text-center text-muted my-4">
                اطلاعات بیشتری برای نمایش وجود ندارد
              </p>
            }
          >
            <div className="container">
              <div className="row row-cols-1 row-cols-md-2 g-4">
                {items.map((item) => (
                  <div className="col" key={item.id}>
                    <CardOperdonView service={item} />
                  </div>
                ))}
              </div>
            </div>

            {error && (
              <div className="text-center text-danger my-3">
                خطایی در بارگذاری اطلاعات رخ داد. لطفاً دوباره تلاش کنید.
              </div>
            )}
          </InfiniteScroll>
        </>
      )}
    </Fragment>
  );
};

export default OperdonInfinitPaging;
